export const STORAGE_KEYS = {
  token: 'TOKEN',
  tempToken: 'TEMP_TOKEN',
  userData: 'USER_DATA',
  redirectPath: 'REDIRECT_PATH',
  role: 'USER_ROLE',
};
